import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useT } from "@/lib/i18n";
import { PageHeader, Stat } from "./shared";

export default function OverviewTab() {
    const { t } = useT();
    const [stats, setStats] = useState(null);
    useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)); }, []);
    return (
        <div data-testid="admin-overview">
            <PageHeader eyebrow={`${t("admin.overview")} · Wild Coffee`} title={t("admin.atAGlance")} />
            {!stats ? (
                <div className="font-serif text-2xl text-espresso">Loading…</div>
            ) : (
                <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-12">
                    <Stat label={t("admin.stats.totalReservations")} value={stats.total_bookings} />
                    <Stat label={t("admin.stats.pending")} value={stats.pending_bookings} accent />
                    <Stat label={t("admin.stats.confirmed")} value={stats.confirmed_bookings} />
                    <Stat label={t("admin.stats.cabins")} value={stats.total_cabins} />
                    <Stat label={t("admin.stats.guests")} value={stats.total_users} />
                    <Stat label={t("admin.stats.newInquiries")} value={stats.new_inquiries} accent />
                    <Stat label={t("admin.stats.pendingReviews")} value={stats.pending_reviews ?? 0} accent />
                    <Stat label={t("admin.stats.newsletterSubs")} value={stats.newsletter_subscribers ?? 0} />
                    <Stat label={t("admin.stats.revenueConfirmed")} value={`$${Number(stats.revenue).toLocaleString()}`} />
                    <Stat label={t("admin.stats.occupancy30d")} value={`${stats.occupancy_pct_30d}%`} />
                </div>
            )}
        </div>
    );
}
